// extracted by mini-css-extract-plugin
export default {"pageSection":"pageSection_pageSection__Uh4v2","pageSection__title":"pageSection_pageSection__title__Ihwgf"};